import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../Modal/Modal'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import Button from '../Button/Button'

const ModalInfo = ({ visible, title, description, callbackButtonOk }) => {
  return (
    <Modal visible={visible} rounded size="medium">
      <Flex column justifyContent="center" alignItems="center">
        <Text
          size="lg"
          color="gray"
          variation="dark"
          fontWeight="700"
          margin="24px 0px"
        >
          {title}
        </Text>
        <Text
          size="sm"
          color="gray"
          variation="dark"
          font="custom"
          fontWeight="400"
          alignText="center"
          margin="0px 0px 24px 0px"
        >
          {description}
        </Text>
        <Button type="secondary" buttonType="button" onClick={callbackButtonOk}>
          OK
        </Button>
      </Flex>
    </Modal>
  )
}

ModalInfo.defaultProps = {
  visible: false,
  title: '',
  description: ''
}

ModalInfo.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  callbackButtonOk: PropTypes.func.isRequired
}

export default React.memo(ModalInfo)
